/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type NotesWidgetContainer_widget$ref: FragmentReference;
export type NotesWidgetContainer_widget = {|
  +id: string,
  +name: ?string,
  +enabled: ?boolean,
  +visible: ?boolean,
  +data: ?string,
  +type: ?string,
  +$refType: NotesWidgetContainer_widget$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "NotesWidgetContainer_widget",
  "type": "Widget",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "enabled",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "visible",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "data",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5310709e262754d5c517227bec22c4b8';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Widget/Widgets/Notes/__generated__/NotesWidgetContainer_widget.graphql.js